import Common from "./Global/Common"
import Menu from "./Global/Menu"
import SideMenu from "./Global/SideMenu"
import SetSameHeight from "./Global/SetSameHeight";
import Popup from "./Global/Popup";
import Ready from "./Helpers/Ready.js"
import LogoSlider from "./Blocks/LogoSlider";
import CardSlider from "./Blocks/CardSlider";
import ImageSlider from "./Blocks/ImageSlider";
import ImageTextSlider from "./Blocks/ImageTextSlider";
import Tab from "./Blocks/Tab";
import TestimonialsSlider from "./Blocks/TestimonialsSlider";
import ServicesSlider from "./Blocks/ServicesSlider";
import Video from "./Blocks/Video";
import Faq from "./Blocks/Faq";
import RoomSlider from "./Blocks/RoomSlider";

import HeroSlider from "./Blocks/HeroSlider";

Ready(
	() => {
		const common = new Common()
		common.init()

		// const menu = new Menu()
		// menu.init()

		const sideMenu = new SideMenu()
		sideMenu.init()

		// const popup = new Popup()
		// popup.init()
		//
		// const setSameHeight = new SetSameHeight()
		// setSameHeight.init()
		//
		// const logoSlider = new LogoSlider();
		// logoSlider.init();
		//
		// const cardSlider = new CardSlider();
		// cardSlider.init();
		//
		// const imageSlider = new ImageSlider();
		// imageSlider.init();
		//
		// const testimonialsSlider = new TestimonialsSlider();
		// testimonialsSlider.init();
		//
		// const servicesSlider = new ServicesSlider();
		// servicesSlider.init();
		//
		// const imageTextSlider = new ImageTextSlider();
		// imageTextSlider.init();
		//
		// const tab = new Tab();
		// tab.init();
		//
		// const video = new Video();
		// video.init();
		//
		// const faq = new Faq();
		// faq.init();

		// const heroSlider = new HeroSlider();
		// heroSlider.init();

		const roomSlider = new RoomSlider();
		roomSlider.init();

	}
)
